module.exports = __webpack_public_path__ + "static/media/mountains-1.ac4b8758.png";